import { Stack } from '@mui/material';
import { memo } from 'react';
import { SelloutProductColor } from '../../../../../../../../../../../../services/modules/product-color-sellout/product-color-sellout.types';
import SelloutLeftColumnsDataRows from './SelloutLeftColumnsDataRows';
import SelloutLeftColumnsDistributionRow from './SelloutLeftColumnsDistributionRow';

interface SelloutLeftColumnsProps {
  selloutProductColor: SelloutProductColor;
  pieces: number;
  disabled: boolean;
  onChangePieces: (value: number) => void;
}

const SelloutLeftColumns = ({
  pieces,
  disabled,
  selloutProductColor,
  onChangePieces,
}: SelloutLeftColumnsProps) => {
  return (
    <Stack>
      <SelloutLeftColumnsDataRows selloutProductColor={selloutProductColor} />

      <SelloutLeftColumnsDistributionRow
        pieces={pieces}
        disabled={disabled}
        onChangePieces={onChangePieces}
      />
    </Stack>
  );
};

export default memo(SelloutLeftColumns);
